import EditorBar from './EditorBar';

export default EditorBar;
